import { useEffect } from "react";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
}

export function usePageMeta(title, description) {
  useEffect(() => {
    if (!title) return;
    const prevTitle = document.title;
    const prevDesc = document.head.querySelector('meta[name="description"]')?.getAttribute("content");
    document.title = `${title} | FYDATE`;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:title", `${title} | FYDATE`);
      setMeta("property", "og:description", description);
    }
    return () => {
      document.title = prevTitle;
      if (prevDesc) setMeta("name", "description", prevDesc);
    };
  }, [title, description]);
}
